class ScoliaProductComparison extends HTMLElement {
  connectedCallback() {
    if (this.dataset.clickableCellsReady === 'true') return;
    this.dataset.clickableCellsReady = 'true';

    this.addEventListener('click', (event) => {
      const cell = event.target.closest('[data-product-url]');
      if (!cell || !this.contains(cell)) return;

      const interactiveTarget = event.target.closest(
        'a, button, input, select, textarea, label, summary, [role="button"], [role="link"]'
      );

      if (interactiveTarget && interactiveTarget !== cell) return;

      const url = cell.getAttribute('data-product-url');
      if (url) window.location.href = url;
    });
  }
}

if (!customElements.get('scolia-product-comparison')) {
  customElements.define('scolia-product-comparison', ScoliaProductComparison);
}
